module.exports = __webpack_public_path__ + "static/sharevel-vpc-9d84dbfbed272d3fff154e8dda464528.png";